window.addEventListener('DOMContentLoaded', () =>
{
  const Pageurl = window.location;
  const titleId = 'social_share_title';
  const social = {
    vk: {
      id: 'vk', url: 'https://vk.com/share.php?url=', title: '&title=',
    },
    ok: {
      id: 'ok', url: 'https://connect.ok.ru/offer?url=', title: '&title=',
    },
    tg: {
      id: 'tg', url: 'https://t.me/share/url?url=', title: '&text=',
    },
  };

  if(document.getElementById(titleId))
  {
    for(const [key, value] of Object.entries(social))
    {

      if(document.getElementById(value.id))
      {
        const title = document.getElementById(titleId).innerHTML;
        const url = social[key].url + Pageurl + social[key].title + title;
        document.getElementById(value.id).href = url;
      }
    }
  }

});
